import React from 'react';
import { motion } from 'framer-motion';
const steps = [{
  number: '1',
  title: 'Drop Your First Pin',
  description: 'Search or tap anywhere on the terrain map to mark a discovery.'
}, {
  number: '2',
  title: 'Open Your Fieldbook',
  description: 'Add notes, photos, and route plans anchored to your pins.'
}, {
  number: '3',
  title: 'Set Your Course',
  description: 'Connect pins into routes with terrain-aware planning and share your atlas.'
}];
export function HowItWorks() {
  return <section className="py-24 bg-forest text-parchment relative overflow-hidden" data-id="element-135">
      {/* Background Topography */}
      <div className="absolute inset-0 opacity-5" data-id="element-136">
        <svg className="w-full h-full" viewBox="0 0 100 100" preserveAspectRatio="none" data-id="element-137">
          <path d="M0,0 Q50,50 100,0 V100 H0 Z" fill="none" stroke="currentColor" strokeWidth="0.5" data-id="element-138" />
          <path d="M0,20 Q50,70 100,20" fill="none" stroke="currentColor" strokeWidth="0.5" data-id="element-139" />
          <path d="M0,40 Q50,90 100,40" fill="none" stroke="currentColor" strokeWidth="0.5" data-id="element-140" />
        </svg>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-141">
        <div className="text-center mb-20" data-id="element-142">
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-parchment mb-4" data-id="element-143">
            Three Steps to Your First Expedition
          </h2>
          <div className="w-24 h-1 bg-gold mx-auto rounded-full" data-id="element-144" />
        </div>

        <div className="relative grid md:grid-cols-3 gap-12" data-id="element-145">
          {/* Connecting Line (Desktop) */}
          <div className="hidden md:block absolute top-12 left-0 w-full h-0.5 border-t-2 border-dashed border-gold/30 z-0" data-id="element-146" />

          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: index * 0.2
        }} viewport={{
          once: true
        }} className="relative z-10 text-center" data-id="element-147">
              <div className="w-24 h-24 mx-auto bg-forest border-4 border-gold rounded-full flex items-center justify-center mb-8 shadow-xl relative" data-id="element-148">
                <span className="font-serif font-bold text-4xl text-gold" data-id="element-149">
                  {step.number}
                </span>
                {/* Decorative dots around circle */}
                <div className="absolute inset-0 border-2 border-dashed border-parchment/20 rounded-full scale-110" data-id="element-150" />
              </div>

              <h3 className="text-2xl font-serif font-bold text-gold mb-4" data-id="element-151">
                {step.title}
              </h3>

              <p className="text-parchment/80 font-sans leading-relaxed max-w-sm mx-auto" data-id="element-152">
                {step.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}